import React from 'react';
import { Spin } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { PackageCard } from 'components/warehouse';
import { useOutboundPackages } from './useOutboundPackages';
import type { OutboundFilters } from 'models/Warehouse';
import styles from './styles.module.scss';

interface OutboundPackagesProps {
  searchValue?: string;
  filters?: OutboundFilters;
}

export const OutboundPackages: React.FC<OutboundPackagesProps> = ({ searchValue = '', filters = {} }) => {
  const { allPackages, isLoading, page, hasMore, loadMore, handleCardClick } = useOutboundPackages({
    searchValue,
    filters,
  });

  if (isLoading && page === 1) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingContainer}>
          <Spin size="large" />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div id="scrollableDivOutbound" className={styles.scrollContainer}>
        <InfiniteScroll
          dataLength={allPackages.length}
          next={loadMore}
          hasMore={hasMore}
          loader={
            <div className={styles.loadingMore}>
              <Spin />
            </div>
          }
          scrollableTarget="scrollableDivOutbound"
        >
          <div className={styles.packageList}>
            {allPackages.map((pkg) => (
              <PackageCard key={pkg.id} package={pkg} onClick={() => handleCardClick(pkg.id)} type="outbound" />
            ))}
          </div>
        </InfiniteScroll>
      </div>
    </div>
  );
};
